import React, { useState } from "react";
import {
  Box,
  InputBase,
  IconButton,
  Paper,
  useTheme,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import SpeechToTextButton from "../../utility/SpeechToTextButton";
import axios from 'axios';
import { get } from "../../utility/fetchWeb";

const DoctorSearchBar = ({handleChange, setData, kind}) => {
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState("");
  const [doctors, setDoctors] = useState([]);

  const handleTranscript = async (transcript) => {
    setSearchQuery(transcript);
    try {
      const response = await get(
        `/Doctors/GetRecommendedDoctors?summary=${encodeURIComponent(transcript)}`
      );
      setDoctors(response);
      setData(response);
      console.log('Recommended doctors:', response);
    } catch (error) {
      console.error('Error fetching doctors:', error);
    }
  };



  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%",
        mt: 2,
      }}
    >
      {/* Search Input Section */}
      <Paper
        component="form"
        sx={{
          p: "8px 8px",
          display: "flex",
          alignItems: "center",
          flex: 1,
          borderRadius: "999px",
          backgroundColor: "#f9f9f5",
          boxShadow: "none",
          border: "1px solid #eee",
        }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search for a Doctor"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          inputProps={{ "aria-label": `search for a ${kind}` }}
          // onChange={handleChange} // Handle input change
        />
        <IconButton type="submit" sx={{ p: "6px" }} aria-label="search">
          <SearchIcon fontSize="small" />
        </IconButton>
      </Paper>

      {/* Filter Button */}
      <IconButton
        aria-label="filter"
        sx={{
          border: "1px solid #eee",
          borderRadius: 2,
          backgroundColor: "#fff",
          "&:hover": {
            backgroundColor: "#E8FFDA",
          },
        }}
      >
        <FilterListIcon />
      </IconButton>

      {/* Mic/Voice Button */}
      <SpeechToTextButton onTranscript={handleTranscript} />
    </Box>
  );
};

export default DoctorSearchBar;
